import React, { useMemo } from 'react';

import CountryFlag from "../CountryFlag";
// import { getCountryName } from "../../../../../components/interop/countryCodeConverterFront"
import __ from '../../../../../components/interop/i18n';
import SingleValueSelector from './SingleValueSelector';

const countries = __('countryCodeToName');

export default function MultiCountryEditor(props) {
  const options = useMemo(() => {
    let options = Object.keys(countries).map(key => ({
      value: key, label: <div className={'p-1 d-flex'}>
        <CountryFlag countryCode={key} className='mr-1' /> {countries[key]}
      </div>
    }));
    options.push({ value: '*', label: <span>ALL</span> });
    
    return options;
  }, [countries]);

  return <SingleValueSelector {...props} options={options} />
}

